export const CREDIT_CARDS_ONLY = {
  TYPE: 7,
};

export const DRIVERS_LICENSE_DOCUMENT = {
  ID: 12,
};
